export const NEW_STORY_REQUEST = "NEW_STORY_REQUEST";
export const NEW_STORY_SUCCESS = "NEW_STORY_SUCCESS";
export const NEW_STORY_RESET = "NEW_STORY_RESET";
export const NEW_STORY_FAIL = "NEW_STORY_FAIL";

export const USER_STORIES_REQUEST = "USER_STORIES_REQUEST";
export const USER_STORIES_SUCCESS = "USER_STORIES_SUCCESS";
export const USER_STORIES_FAIL = "USER_STORIES_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
